import { ALMHistoricalChartMode } from './alm-historical-chart-generator';
import { Component, OnInit, ViewEncapsulation, SimpleChanges, OnChanges, Input } from '@angular/core';
import * as am4core from '@amcharts/amcharts4/core';
import * as am4charts from '@amcharts/amcharts4/charts';
import { SelectItem } from 'primeng/api';
import { createALMHistoricalChart, ALMHistoricalData } from './alm-historical-chart-generator';
import { convertFromConstantToHuman } from '@liquitics/transaction';

@Component({
    selector: 'app-alm-historical-chart',
    templateUrl: './alm-historical-chart.component.html',
    styleUrls: ['./alm-historical-chart.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class ALMHistoricalChartComponent implements OnInit, OnChanges {
    @Input()
    title: string;
    @Input()
    historicalData: ALMHistoricalData[];
    @Input()
    index: number = 0;
    historicalModes: SelectItem[];
    selectedHistoricalMode: ALMHistoricalChartMode;
    chart: am4charts.Chart;
    initialized = true;
    isPopup = false;

    ngOnInit(): void {
        this.historicalModes = ['HISTORY', 'ROLLING_15_DAY', 'ROLLING_30_DAY']
            .map((mode: string) => {
                return { label: convertFromConstantToHuman(mode), value: mode } as SelectItem;
            });
        this.selectedHistoricalMode = this.historicalModes[0].value;
    }

    updateChart() {
        if (this.chart) {
            this.chart.dispose();
        }
        this.chart = createALMHistoricalChart(`historicalchartdiv${this.index}`, this.historicalData, this.selectedHistoricalMode);
        const chartTitle = this.chart.titles.create();
        chartTitle.text = this.title;
        this.initialized = true;
    }

    ngOnChanges(changes: SimpleChanges) {
        if (this.historicalData) {
            this.updateChart();
        }
    }
    onHistoricalModeSelected() {
        if (this.historicalData) {
            this.updateChart();
        }
    }

    setToLoading() {
        this.initialized = false;
    }
    togglePopup() {
        this.isPopup = !this.isPopup;
        // if (this.isPopup) {
        //     setTimeout(() => {
        //         createALMHistoricalChart(`popuphistoricalchartdiv${this.index}`, this.historicalData, this.selectedHistoricalMode);
        //     }, 100);
        // }
    }
}
